import { CollectionTimeline } from '../components/collection-timeline';
import { t } from '../i18n';

export const CollectionRecordsPage = () => (
  <section>
    <div className="hero-copy compact-hero">
      <p className="eyebrow">TIMELINE</p>
      <h1>{t('collectionRecords')}</h1>
    </div>
    <CollectionTimeline variant="page" />
  </section>
);
